export const GET_PROFILE = 'GET_PROFILE';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';



// WEBPACK FOOTER //
// ./src/actions/profile/types.js